import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';
import { MaterialCheckbox } from '../../material/MaterialCheckbox';
import { i18n } from '../../i18n/translate';

export class FormSaveButtons extends React.Component {
  static propTypes = {
    branded: PropTypes.bool,
    cancel: PropTypes.func,
    cancelButtonText: PropTypes.string,
    cancelIconType: PropTypes.string,
    className: PropTypes.string,
    buttonBaseClass: PropTypes.string,
    buttonStyle: PropTypes.string,
    buttonStyleSecondary: PropTypes.string,
    buttonStyleDelete: PropTypes.string,
    dataId: PropTypes.string,
    dataType: PropTypes.string,
    delete: PropTypes.func,
    deleteButtonText: PropTypes.string,
    deleteIconType: PropTypes.string,
    isDisabled: PropTypes.bool,
    leftButtonStyle: PropTypes.string,
    leftButtonText: PropTypes.string,
    leftButtonClick: PropTypes.func,
    leftButtonIconType: PropTypes.string,
    noPaddingButtons: PropTypes.bool,
    save: PropTypes.func,
    saveAndAdd: PropTypes.func,
    saveAndAddButtonDisabled: PropTypes.bool,
    saveAndAddButtonText: PropTypes.string,
    saveAndAddCheckbox: PropTypes.bool,
    saveAndAddCheckboxClass: PropTypes.string,
    saveAndAddCheckboxText: PropTypes.string,
    saveAndAddIconType: PropTypes.string,
    saveButtonAreaClassName: PropTypes.string,
    saveButtonDisabled: PropTypes.bool,
    renderAsLegacy: PropTypes.bool,
    saveButtonText: PropTypes.string,
    saveButtonDataAction: PropTypes.string,
    saveIconType: PropTypes.string,
  };

  static defaultProps = {
    branded: false,
    isDisabled: false,
    saveButtonDisabled: false,
    buttonBaseClass: 'btn',
    buttonStyle: 'primary',
    buttonStyleSecondary: 'secondary',
    buttonStyleDelete: 'primary',
    className: '',
    saveButtonAreaClassName: '',
    renderAsLegacy: false,
  };

  constructor(props) {
    super(props);
  }

  buildCheckbox(show, btn_class, text, disabled) {
    if (show) {
      return (
        <MaterialCheckbox
          data-object-type={this.props.dataType}
          data-object-id={this.props.dataId}
          data-object-action={`form-save-add-another`}
          className={`${btn_class} left-checkbox`}
          disabled={disabled}
          inline={true}
          name="saveAndAddCheckbox"
        >
          {text}
        </MaterialCheckbox>
      );
    }
  }

  buildButton({ func, id, className, style, text, iconType, disabled, showLoader, dataAction }) {
    if (!func) return;

    const computedStyle = showLoader ? `${style} btn-icon-text` : style;
    const computedIcon = showLoader ? 'spinner' : iconType;

    return (
      <Button
        branded={this.props.branded}
        className={this.props.renderAsLegacy ? className : 'm-l-10'}
        data-action={dataAction}
        data-object-type={this.props.dataType}
        data-object-id={this.props.dataId}
        data-object-action={`form-${id}`}
        disabled={this.props.isDisabled || disabled}
        icon={computedIcon}
        id={`${this.props.className}-${id}`}
        label={text}
        onClick={func}
        style={computedStyle}
        variant={style}
        renderAsLegacy={this.props.renderAsLegacy}
      />
    );
  }

  render() {
    const {
      buttonBaseClass,
      buttonStyle,
      buttonStyleDelete,
      buttonStyleSecondary,
      cancel,
      cancelButtonText,
      cancelIconType,
      className,
      deleteButtonText,
      deleteIconType,
      isDisabled,
      leftButtonStyle,
      leftButtonText,
      leftButtonClick,
      leftButtonIconType,
      noPaddingButtons,
      save,
      saveIconType,
      saveAndAdd,
      saveAndAddButtonDisabled,
      saveAndAddButtonText,
      saveAndAddCheckbox,
      saveAndAddCheckboxClass,
      saveAndAddCheckboxText,
      saveAndAddIconType,
      saveButtonAreaClassName,
      saveButtonDisabled,
      saveButtonText,
      saveButtonDataAction,
    } = this.props;

    return (
      <div data-action="modal-footer" className={className}>
        <div className="col-3">
          {this.buildButton({
            func: leftButtonClick,
            id: 'left-button',
            className: buttonBaseClass,
            style: leftButtonStyle,
            text: leftButtonText,
            iconType: leftButtonIconType,
          })}
          {this.buildButton({
            func: this.props.delete,
            id: 'delete',
            className: buttonBaseClass,
            style: buttonStyleDelete,
            text: deleteButtonText || i18n.t('Delete'),
            iconType: deleteIconType,
          })}
        </div>
        <div className={`col-9 ${saveButtonAreaClassName} ${noPaddingButtons ? 'no-padding' : ''}`}>
          {this.buildCheckbox(
            saveAndAddCheckbox,
            saveAndAddCheckboxClass,
            saveAndAddCheckboxText || i18n.t('Save and Add Another')
          )}
          {this.buildButton({
            func: cancel,
            id: 'cancel',
            className: buttonBaseClass,
            style: buttonStyleSecondary,
            text: cancelButtonText || i18n.t('Cancel'),
            iconType: cancelIconType,
          })}
          {this.buildButton({
            func: save,
            id: 'save',
            className: buttonBaseClass,
            style: buttonStyle,
            text: saveButtonText || i18n.t('Save'),
            iconType: saveIconType,
            disabled: saveButtonDisabled,
            showLoader: isDisabled,
            dataAction: saveButtonDataAction,
          })}
          {this.buildButton({
            disabled: saveAndAddButtonDisabled,
            func: saveAndAdd,
            id: 'save-and-add',
            className: buttonBaseClass,
            style: buttonStyle,
            text: saveAndAddButtonText || i18n.t('Save and Add Another'),
            iconType: saveAndAddIconType,
          })}
        </div>
      </div>
    );
  }
}
